import { BOX_SHADOW, COLORS } from './colorScheme';

/**
 * @type {import('@mui/material/styles').PaletteOptions}
 */
const PALETTE_1 = {
    backgroundColor: COLORS.heather,
    textHeading: COLORS.oat,
    textBody: COLORS.oat,
    button: {
        contained: {
            background: COLORS.sunset,
            backgroundHover: COLORS.sunset30,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
        outlined: {
            background: COLORS.white,
            backgroundHover: COLORS.sunset,
            textColor: COLORS.sunset,
            textHoverColor: COLORS.white,
        },
        text: {
            textColor: COLORS.oat,
            textHoverColor: COLORS.oat,
        },
        inactive: {
            background: COLORS.grey550,
            backgroundHover: COLORS.grey550,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
    },
    boxShadow: BOX_SHADOW.boxShadow1,
};

const PALETTE_2 = {
    backgroundColor: COLORS.white,
    textHeading: COLORS.heather,
    textBody: COLORS.heather,
    button: {
        contained: {
            background: COLORS.sunset,
            backgroundHover: COLORS.sunset30,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
        outlined: {
            background: COLORS.white,
            backgroundHover: COLORS.sunset,
            textColor: COLORS.sunset,
            textHoverColor: COLORS.white,
        },
        text: {
            textColor: COLORS.heather,
            textHoverColor: COLORS.heather,
        },
        inactive: {
            background: COLORS.grey550,
            backgroundHover: COLORS.grey550,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
    },
    boxShadow: BOX_SHADOW.boxShadow1,
};
const PALETTE_3 = {
    backgroundColor: COLORS.oat,
    textHeading: COLORS.heather,
    textBody: COLORS.heather,
    button: {
        contained: {
            background: COLORS.sunset,
            backgroundHover: COLORS.sunset30,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
        outlined: {
            background: COLORS.white,
            backgroundHover: COLORS.sunset,
            textColor: COLORS.sunset,
            textHoverColor: COLORS.white,
        },
        text: {
            textColor: COLORS.heather,
            textHoverColor: COLORS.heather,
        },
        inactive: {
            background: COLORS.grey550,
            backgroundHover: COLORS.grey550,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
    },
    boxShadow: BOX_SHADOW.boxShadow1,
};
const PALETTE_4 = {
    backgroundColor: COLORS.heather80,
    textHeading: COLORS.oat,
    textBody: COLORS.oat,
    button: {
        contained: {
            background: COLORS.sunset,
            backgroundHover: COLORS.sunset30,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
        outlined: {
            background: COLORS.white,
            backgroundHover: COLORS.sunset,
            textColor: COLORS.sunset,
            textHoverColor: COLORS.white,
        },
        text: {
            textColor: COLORS.oat,
            textHoverColor: COLORS.oat,
        },
        inactive: {
            background: COLORS.grey550,
            backgroundHover: COLORS.grey550,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
    },
    boxShadow: BOX_SHADOW.boxShadow1,
};
const PALETTE_5 = {
    backgroundColor: COLORS.white,
    textHeading: COLORS.heather,
    textBody: COLORS.heather,
    button: {
        contained: {
            background: COLORS.white,
            backgroundHover: COLORS.sunset,
            textColor: COLORS.heather,
            textHoverColor: COLORS.white,
        },
        outlined: {
            background: COLORS.white,
            backgroundHover: COLORS.sunset,
            textColor: COLORS.sunset,
            textHoverColor: COLORS.white,
        },
        text: {
            textColor: COLORS.heather,
            textHoverColor: COLORS.heather,
        },
        inactive: {
            background: COLORS.grey550,
            backgroundHover: COLORS.grey550,
            textColor: COLORS.white,
            textHoverColor: COLORS.white,
        },
    },
    boxShadow: BOX_SHADOW.boxShadow1,
};

export { PALETTE_1, PALETTE_2, PALETTE_3, PALETTE_4, PALETTE_5 };
